import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoughCaverns = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M16.11 5H27.5L43 27.5 35 43H12.5L5 20zm1.39 3-9 12.5L15 40h18l6.5-12.227L26 8z" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.11 5H27.5L43 27.5 35 43H12.5L5 20zm.828 1.5L6.665 20.176 13.549 41.5h20.53l7.187-13.812L26.902 6.5z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 28.919,
			y: 23.313,
			transform: "rotate(100 28.92 23.313)"
		}),
		/* @__PURE__ */ _jsx("path", { d: "m26.6 21.341-1.91 10.833-.985-.174 1.91-10.833zM24.282 19.367 22.372 30.2l-.985-.174 1.91-10.833zM21.964 17.394l-1.91 10.833-.985-.174 1.91-10.833zM19.646 15.421l-1.91 10.833-.985-.174 1.91-10.833z" })
	]
});
export default SvgRoughCaverns;
